import React, { useState, useEffect, useRef, useContext } from 'react'
import { getSrc } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { StoreDispatch } from '../../Store'

// Components
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import RichText from '../RichText'

// Utils
import { disablePageScroll, enablePageScroll } from '../../utils/utils'

// Styles
import {
  CarouselModal,
  CarouselModalInner,
  CarouselImageWrap,
  CarouselImage,
  CarouselContent,
  CloseButton,
} from './index.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'

const Modal = ({ activeItem, modalOpen, setModalOpen, setModalItem }) => {
  const [visible, setVisible] = useState(false)
  const [scrollY, setScrollY] = useState()
  const delayTimeout = useRef(null)

  const dispatch = useContext(StoreDispatch)

  useEffect(() => {
    if (modalOpen) {
      dispatch({ type: 'SHOW_MODAL' })
      setScrollY(window.pageYOffset)
      setTimeout(disablePageScroll, 1000)
      delayTimeout.current = setTimeout(() => setVisible(true), 250)
    } else {
      enablePageScroll()
      if (window.innerWidth < breakpoints.tabletL) window.scrollTo(0, scrollY)
      setVisible(false)
      delayTimeout.current = setTimeout(() => {
        setModalItem(-1)
        dispatch({ type: 'HIDE_MODAL' })
      }, 1100)
    }

    return () => {
      delayTimeout.current && clearTimeout(delayTimeout.current)
    }
  }, [dispatch, modalOpen, setModalItem, setVisible, scrollY])

  let imageSource = activeItem && getSrc(activeItem.image.gatsbyImageData)

  return (
    <CarouselModal modalIsOpen={modalOpen} data-inview={modalOpen}>
      <Container>
        {activeItem && (
          <CarouselModalInner>
            <CarouselImageWrap visible={visible}>
              <CarouselImage
                src={imageSource}
                alt={activeItem.image.description}
              />
            </CarouselImageWrap>
            <CarouselContent>
              <Grid>
                <GridItem tiny={10} tabletL={11}>
                  {activeItem.featuredCaption && (
                    <RichText
                      content={activeItem.featuredCaption}
                      delay={1}
                      id={`carousel-rich-text`}
                      useInView={false}
                      isInView={visible}
                    />
                  )}
                </GridItem>
                <GridItem
                  tiny={2}
                  tinyAlign={`flex-start`}
                  tabletL={1}
                  tabletLStart={12}
                  tabletLAlign={`flex-end`}
                >
                  <CloseButton
                    onClick={() => setModalOpen(false)}
                    visible={visible}
                  >
                    <span></span>
                    <span></span>
                  </CloseButton>
                </GridItem>
              </Grid>
            </CarouselContent>
          </CarouselModalInner>
        )}
      </Container>
    </CarouselModal>
  )
}

Modal.propTypes = {
  activeItem: PropTypes.object,
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  setModalItem: PropTypes.func,
}

export default Modal
